module.exports = __webpack_public_path__ + "static/media/loader.7627bc82.svg";